import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FerienhauserofferRoutingModule } from './ferienhauseroffer-routing.module';
import { FerienhauserofferComponent } from './ferienhauseroffer.component';
import { AngularMaterialModule } from '@app/material.module';
import { FerienhauserofferdetailComponent } from './ferienhauserofferdetail/ferienhauserofferdetail.component';
import { FerienhauserofferzeitComponent } from './ferienhauserofferzeit/ferienhauserofferzeit.component';
import { PipeModule } from '@app/pipe/pipe.module';
import { FerienhauserofferprcsComponent } from './ferienhauserofferprcs/ferienhauserofferprcs.component';
import { HeaderModule } from '../header/header.module';
import { FooterModule } from '../footer/footer.module';
import { ImagesliderComponent } from '../imageslider/imageslider.component';
import { ShareComponent } from '../share/share.component';
import { FormsModule } from '@angular/forms';
import { CleverdatepickerModule } from '../cleverdatepicker/cleverdatepicker.module';
import { DirectiveModule } from '@app/directives/directive.module';

@NgModule({
    declarations: [
        FerienhauserofferComponent,
        FerienhauserofferdetailComponent,
        FerienhauserofferzeitComponent,
        FerienhauserofferprcsComponent
    ],
    imports: [
        FormsModule,
        CommonModule,
        FerienhauserofferRoutingModule,
        AngularMaterialModule,
        ImagesliderComponent,
        CleverdatepickerModule,
        PipeModule,
        DirectiveModule,
        HeaderModule,
        FooterModule,
        ShareComponent
    ]
})
export class FerienhauserofferModule { }
